import { render, staticRenderFns } from "./WithdrawalList.vue?vue&type=template&id=2d0fd67c&scoped=true"
import script from "./WithdrawalList.vue?vue&type=script&lang=js"
export * from "./WithdrawalList.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalList.vue?vue&type=style&index=0&id=2d0fd67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0fd67c",
  null
  
)

export default component.exports